import SeoHead from "../components/SeoHead";
import { getSiteContent, localeRoutes } from "../i18n/siteContent";

function AboutPage({ locale = "en" }) {
    const site = getSiteContent(locale);
    const text = site.about;
    const routes = localeRoutes[locale];
    const breadcrumbItems = [
        { name: site.nav.home, path: routes.home },
        { name: site.nav.about, path: routes.about }
    ];

    return (
        <>
            <SeoHead
                title={text.title}
                description={text.description}
                keywords="Maurizio Brioschi about, fractional cto profile, solution architect profile, digital transformation consultant, cloud strategy, technical leadership"
                path={routes.about}
                locale={locale}
                enPath={localeRoutes.en.about}
                itPath={localeRoutes.it.about}
                breadcrumbItems={breadcrumbItems}
            />
            <main className="mx-auto max-w-6xl px-4 py-10 sm:px-6">
                <header>
                    <p className="text-xs font-semibold uppercase tracking-[0.3em] text-slate-500">{text.label}</p>
                    <h1 className="mt-3 text-4xl font-impact text-slate-900">{text.heading}</h1>
                    <p className="mt-4 max-w-3xl text-slate-600">{text.intro}</p>
                </header>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.principlesTitle}</h2>
                    <ul className="mt-4 space-y-2 text-sm text-slate-700">
                        {text.principles.map((item) => (
                            <li key={item}>- {item}</li>
                        ))}
                    </ul>
                    <p className="mt-4 text-sm text-slate-600">{text.remote}</p>
                </section>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.operatingTitle}</h2>
                    <ul className="mt-4 space-y-2 text-sm text-slate-700">
                        {text.operatingPoints.map((item) => (
                            <li key={item}>- {item}</li>
                        ))}
                    </ul>
                </section>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.cvTitle}</h2>
                    <p className="mt-2 text-sm text-slate-600">{text.cvIntro}</p>
                    <div className="mt-4 flex flex-wrap gap-3">
                        <a
                            href="/assets/cv/maurizio-brioschi-cv-en.pdf"
                            target="_blank"
                            rel="noopener"
                            download
                            className="rounded-full bg-slate-900 px-5 py-3 text-sm font-semibold text-white transition hover:bg-slate-700"
                        >
                            {text.cvEn}
                        </a>
                        <a
                            href="/assets/cv/maurizio-brioschi-cv-it.pdf"
                            target="_blank"
                            rel="noopener"
                            download
                            className="rounded-full border border-slate-300 px-5 py-3 text-sm font-semibold text-slate-800 transition hover:bg-slate-100"
                        >
                            {text.cvIt}
                        </a>
                    </div>
                </section>

                <section className="mt-8 rounded-2xl border border-slate-200 bg-white p-6">
                    <h2 className="text-2xl font-impact text-slate-900">{text.internalLinksTitle}</h2>
                    <nav className="mt-4 grid gap-3 sm:grid-cols-2" aria-label={text.internalLinksTitle}>
                        {text.internalLinks.map((item) => (
                            <a
                                key={item.href}
                                href={item.href}
                                className="rounded-xl border border-slate-200 px-4 py-3 text-sm font-semibold text-slate-800 transition hover:border-amber-300 hover:text-amber-700"
                            >
                                {item.label}
                            </a>
                        ))}
                    </nav>
                </section>
            </main>
        </>
    );
}

export default AboutPage;
